<div class="app-tabs-container">
    <div class="app-tabs-wrapper">
        <!-- Seta esquerda -->
        <button *ngIf="showArrows" class="app-tabs-arrow app-tabs-arrow-left"
            [class.disabled]="!canScrollLeft" (click)="scrollLeft()"
            [disabled]="!canScrollLeft">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>

        <!-- Container das tabs com scroll -->
        <div class="app-tabs-list" #tabsList (scroll)="onScroll()">
            <ng-container *ngFor="let tab of tabs; let i= index">
                <div class="app-tabs-item" *ngIf="tab"
                    [class.dashboard-tab]="dashboardTab"
                    [class.active]="i === activedTab"
                    [class.disabled]="tab.disabled !== undefined ? tab.disabled : false"
                    [class.d-none]="tab.hided" (click)="activeTab(i, $event)">
                    <span class="app-tabs-item-text">{{tab.label}}</span>
                    <span class="app-tabs-item-badge" [class.active]="tab.error"
                        [class.d-none]="dashboardTab && !tab.error">!</span>
                </div>
            </ng-container>
            <div class="app-tabs-indicator" [style.width]="width"
                [style.left]="posX"></div>
        </div>

        <!-- Seta direita -->
        <button class="app-tabs-arrow app-tabs-arrow-right"
            [class.disabled]="!canScrollRight" (click)="scrollRight()"
            [disabled]="!canScrollRight">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
</div>